import { render, staticRenderFns } from "./WorkspaceMapGenesModal.vue?vue&type=template&id=4539896e&scoped=true"
import script from "./WorkspaceMapGenesModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceMapGenesModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMapGenesModal.vue?vue&type=style&index=0&id=4539896e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4539896e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4539896e')) {
      api.createRecord('4539896e', component.options)
    } else {
      api.reload('4539896e', component.options)
    }
    module.hot.accept("./WorkspaceMapGenesModal.vue?vue&type=template&id=4539896e&scoped=true", function () {
      api.rerender('4539896e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceMapGenesModal.vue"
export default component.exports